<template>
  <div class="stepper-page-container">
    <v-container v-if="!!$store.state.gewerbePraemien.praemien"
                 class="gewerbepage stepper-page" fluid>
      <div
        v-if="!confirmation"
        id="stepperpageContent"
        :class="showSummaryBox ? '' : 'centered'"
        class="area-content"
      >
        <v-stepper :value="currentStepNumber" alt-labels>
          <div id="custom-header-stepper" class="scroll-up-stepper white">
            <v-stepper-header class="custom-stepper">
              <template v-for="step in allSteps">
                <v-stepper-step
                  ref="'stephead' + step.number"
                  :key="'stepkey' + step.number"
                  :class="{toplabel: step.number % 2 === 0}"
                  :complete="step.complete"
                  :step="step.number"
                >{{ step.title }}</v-stepper-step>

                <v-divider v-if="step.number < 5" :key="'dividerkey' + step.number"/>
              </template>
            </v-stepper-header>

            <v-divider/>
          </div>
          <v-stepper-content step="1" class="mb-0 pa-0">
            <gewerbe-step1
              ref="compStep1"
              @step-forward="stepForward"
              @step-back="stepBack"
            />
          </v-stepper-content>

          <v-stepper-content step="2" class="mb-0 pa-0">
            <gewerbe-step2
              ref="compStep2"
              :producterror="producterror"
              @gwproduct-selected="producterror = false"
              @step-forward="stepForward"
              @step-back="stepBack"
            />
          </v-stepper-content>

          <v-stepper-content step="3" class="mb-0 pa-0">
            <gewerbe-step3
              ref="compStep3"
              @step-forward="stepForward"
              @step-back="stepBack"
            />
          </v-stepper-content>

          <v-stepper-content step="4" class="mb-0 pa-0">
            <gewerbe-step4
              ref="compStep4"
              @step-forward="stepForward"
              @step-back="stepBack"
            />
          </v-stepper-content>

          <v-stepper-content step="5" class="mb-0 pa-0">
            <gewerbe-step5
              ref="compStep5"
              @angebot="createAngebot('Angebot')"
              @step-forward="stepForward"
              @step-back="stepBack"
            />
          </v-stepper-content>
        </v-stepper>
      </div>

      <div v-if="showSummaryBox && !confirmation" class="area-summary-box">
        <gewerbe-summary-box state-path="gewerbe" @kurzangebot="createAngebot('Kurzangebot')"/>
      </div>

      <template v-if="confirmation">
        <gewerbe-confirm></gewerbe-confirm>
      </template>
    </v-container>

    <error-message-display :errors="errorSnackbar"/>
    <error-message-display :errors="$store.state.gewerbe.ui.errorSnackbar" mutation="gewerbeHideErrors" />
    <v-dialog
      v-model="angebotDialog.show"
      :width="angebotDialog.width"
      :persistent="!angebotDialog.isSuccess && !angebotDialog.isError"
    >
      <confirm ref="confirm"/>
      <angebot-dialog
        :title="angebotDialog.title"
        :success="angebotDialog.isSuccess"
        :error="angebotDialog.isError"
        :reset="true"
        :hide-pib="true"
        @close="angebotDialog.show=false"
        @open-angebot="openAngebot"
        @reset-angebot="confirmResetDialog"
      />
    </v-dialog>

  </div>
</template>
<script>
import GewerbeConfirm from '../../components/gewerberechner/GewerbeConfirm';
require("@/assets/css/stepperstyle.css");
import StepperPageMixin from "@/components/privatkundenrechner/StepperPageMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import GewerbeStep1 from "@/components/gewerberechner/GewerbeStep1";
import GewerbeStep2 from "@/components/gewerberechner/GewerbeStep2";
import GewerbeStep3 from "@/components/gewerberechner/GewerbeStep3";
import GewerbeStep4 from "@/components/gewerberechner/GewerbeStep4";
import GewerbeStep5 from "@/components/gewerberechner/GewerbeStep5";
import ErrorMessageDisplay from "@/components/ErrorMessageDisplay";
import GewerbeSummaryBox from "@/components/gewerberechner/GewerbeSummaryBox";
import AngebotDialog from "@/components/privatkundenrechner/AngebotDialog";
import confirm from "@/components/helper/confirm";

export default {
  name: "GewerbeAngebotPage",
  components: { GewerbeConfirm, AngebotDialog, confirm, ErrorMessageDisplay, GewerbeStep1, GewerbeStep2, GewerbeStep3, GewerbeStep4, GewerbeStep5, GewerbeSummaryBox },
  mixins: [ValidationMixin, StepperPageMixin],
  data() {
    return {
      confirmation: false
    };
  },
  computed: {
    // indicates if a product was selected in the matrix for validation of step 2 in StepperMixin
    // named productLine because of Privatrechner
    productLine() {
      return this.$store.state.gewerbe.ui.matrixSelection.produkte && this.$store.state.gewerbe.ui.matrixSelection.produkte.length > 0;
    },
    allSteps() {
      return this.$store.state.s.gewerbe.steps;
    },
    currentStepNumber() {
      return this.$store.state.s.gewerbe.activeStepNumber;
    }
  },
  watch: {
    currentStepNumber(newStep, oldStep) {
      if (newStep === 3 && oldStep === 2) {
        this.$store.commit('gewerbeCleanupBaseData');
      }
      if (newStep === 4 && oldStep === 3) {
        this.$store.commit('gewerbeCleanupPersonData');
      }
      if (newStep === 5 && oldStep === 4) {
        this.$store.commit('gewerbeCleanupContractData');
      }
    }
  },
  created() {
    this.$store.dispatch('initializePraemienGewerbeData');
    if (this.currentStepNumber === 6) {
      this.confirmation = true;
    }
  },
  beforeDestroy() {
    if (this.currentStepNumber === 6) {
      this.$store.dispatch("gewerbeResetAngebot");
    }
  },
  methods: {
    stepBack() {
      this.doGewerbePageStep(this.currentStepNumber, this.currentStepNumber - 1);
    },
    stepForward() {
      this.doGewerbePageStep(this.currentStepNumber, this.currentStepNumber + 1);
    },
    doGewerbePageStep(fromstep, tostep) {
      if (tostep === 6) {
        let fnError = (function () {
          this.openInvalidAccordions(fromstep);
          this.errorSnackbar.errormessages = ["Bitte überprüfen Sie Ihre Eingaben."];
          this.errorSnackbar.displayerrors = true;
        }).bind(this);
        let fnSuccess = (function () {
        return this.submitAntrag();  
        //this.stepSuccess(page, fromstep, tostep);
      }).bind(this);

      const validations = this.getStepValidators(fromstep).map(v => v.validateAll());
      return Promise.all(validations)
        .then(res => {
          res.includes(false) ? fnError() : fnSuccess();
        })
        .catch(err => {
          console.log(`VALIDATION ERROR: ${err.message}`);
          fnError();
        });


        
      }
      this.doStep("gewerbe", fromstep, tostep);
    },
    stepSuccess(page, fromstep, tostep) {
      if (fromstep < tostep) {
        this.$store.commit("setStepComplete", {
          page: "gewerbe",
          stepNumber: this.currentStepNumber
        });
      }
      this.$store.commit("doStepTo", {
        page: "gewerbe",
        stepNumber: tostep
      });
      window.scrollTo(0, 0);
      this.confirmation = this.currentStepNumber === 6;
    },
    createAngebot (type) {
      this.angebotDialog.title = type;
      this.showDialog();
      this.$store.dispatch("gewerbeSubmitFormular",{ formularType: type })
        .then((angebot) => {
          this.angebotDialog.pdfUrl = angebot.pdfpfad + "?disposition=inline";
          this.angebotDialog.isSuccess = true;
          this.angebotDialog.width = 650;
        })
        .catch((err) => {
          console.log(`POST OFFER failed with ${err.status}: ${err.message}`);
          this.angebotDialog.isError = true;
        });
    },
    submitAntrag() {
      this.angebotDialog.title = "Antrag";
      this.showDialog();
      this.$store
        .dispatch("gewerbeSubmitFormular", { formularType: "Antrag" })
        .then(() => {
          this.angebotDialog.show = false;
          this.stepSuccess("gewerbe", 5, 6);
        })
        .catch((err) => {
          this.angebotDialog.isError = true;
          console.log(err);
        });
    },
    confirmResetDialog() {
      this.$refs.confirm
        .open("Eingaben zurücksetzen", "Wollen Sie wirklich alle Ihre Eingaben zurücksetzen?", { color: "primary" })
        .then( () => {
          this.resetAngebot();
        });
    },
    resetAngebot() {
      this.$store.dispatch("gewerbeResetAngebot");
      this.angebotDialog.show = false;
      this.clearValidation(this);
      window.scrollTo(0, 0);
    },
  }
};
</script>
